import { render, staticRenderFns } from "./TestimonialPage.vue?vue&type=template&id=221d2e4c"
import script from "./TestimonialPage.vue?vue&type=script&lang=js"
export * from "./TestimonialPage.vue?vue&type=script&lang=js"
import style0 from "./TestimonialPage.vue?vue&type=style&index=0&id=221d2e4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports